
export function getImageUrl (url: string, prefix?: string): string {
    return url?.startsWith('http') ? url : prefix + url;
}